"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsrProvider = void 0;
exports.AsrProvider = {
    Elevenlabs: "elevenlabs",
    RealtimeScribeV1: "realtime_scribe_v1",
};
